// utility
export const PRODUCT_PAGE = new Map([["384595121", "/announce"]]);

const PRODUCT_STATUS = new Map([
  [0, 'Distribution And Can Subscribe'],
  [1, 'Subscribe'],
  [2, 'Subscribe Success'],
  [3, 'Redeming'],
  [4, 'Redeming Success'],
  [5, 'Subscribe Failed'],
]);

const ORDER_TYPE = new Map([
  [0, 'Subscribe'],
  [1, 'Redeming'],
  [2, 'Gain'],
]);

const ORDER_STATUS = new Map([
  [0, 'Confirmation in progress'],
  [1, 'Success'],
  [2, 'Failed'],
]);

export const Product = {
  fromStatus: (id) => {
    return PRODUCT_STATUS.get(id) ?? '';
  },
}

export const Order = {
  fromStatus: (id) => {
    return ORDER_STATUS.get(id) ?? '';
  },
  fromType: (id) => {
    return ORDER_TYPE.get(id) ?? '';
  }
}
